import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Star, Quote } from 'lucide-react';

const testimonialsList = [
  {
    name: "María García",
    role: "Propietaria",
    text: "Javier vendió mi piso en tiempo récord y por encima del precio que esperaba. Su profesionalidad y dedicación marcaron la diferencia.",
    rating: 5
  },
  {
    name: "Carlos Rodríguez",
    role: "Inversor",
    text: "Llevo años confiando en Javier para mis inversiones inmobiliarias. Su conocimiento del mercado y su honestidad son excepcionales.",
    rating: 5
  },
  {
    name: "Ana Martínez",
    role: "Compradora",
    text: "Encontrar nuestra casa fue un proceso tranquilo y emocionante gracias a Javier. Nos guió en cada paso con paciencia y profesionalidad.",
    rating: 5
  }
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonialsList.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonialsList.length) % testimonialsList.length);
  };

  return (
    <section id="testimonios" className="bg-[#f6f5e8] py-20 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-16">
          <div className="max-w-2xl">
            <span className="text-sm text-[#1a365d] tracking-wider uppercase">Testimonios</span>
            <h2 className="text-3xl lg:text-4xl font-light text-[#333333] mt-4 leading-tight">
              Lo que dicen mis clientes
            </h2>
          </div>
          <div className="hidden lg:flex items-center gap-4 mt-6 lg:mt-0">
            <button
              onClick={prevTestimonial}
              className="w-12 h-12 flex items-center justify-center border border-[#bcbbb4] hover:border-[#333333] transition-colors"
              aria-label="Anterior"
            >
              <ChevronLeft className="w-5 h-5 text-[#333333]" />
            </button>
            <button
              onClick={nextTestimonial}
              className="w-12 h-12 flex items-center justify-center border border-[#bcbbb4] hover:border-[#333333] transition-colors"
              aria-label="Siguiente"
            >
              <ChevronRight className="w-5 h-5 text-[#333333]" />
            </button>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonialsList.map((testimonial, idx) => (
            <div
              key={idx}
              className={`bg-[#fffef2] p-8 lg:p-10 transition-all duration-300 ${
                idx === currentIndex ? 'ring-2 ring-[#1a365d]' : ''
              }`}
            >
              <Quote className="w-8 h-8 text-[#1a365d]/20 mb-6" />
              <p className="text-base text-[#333333] leading-relaxed mb-6">
                "{testimonial.text}"
              </p>
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-[#1a365d] text-[#1a365d]" />
                ))}
              </div>
              <div>
                <p className="text-sm font-medium text-[#333333]">{testimonial.name}</p>
                <p className="text-xs text-[#666666]">{testimonial.role}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex lg:hidden items-center justify-center gap-4 mt-8">
          <button
            onClick={prevTestimonial}
            className="w-12 h-12 flex items-center justify-center border border-[#bcbbb4]"
            aria-label="Anterior"
          >
            <ChevronLeft className="w-5 h-5 text-[#333333]" />
          </button>
          <div className="flex items-center gap-2">
            {testimonialsList.map((_, idx) => (
              <span
                key={idx}
                className={`w-2 h-2 rounded-full transition-colors ${
                  idx === currentIndex ? 'bg-[#1a365d]' : 'bg-[#bcbbb4]'
                }`}
              ></span>
            ))}
          </div>
          <button
            onClick={nextTestimonial}
            className="w-12 h-12 flex items-center justify-center border border-[#bcbbb4]"
            aria-label="Siguiente"
          >
            <ChevronRight className="w-5 h-5 text-[#333333]" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
